import { withDefaultNavigation } from '@eig-builder/module-navigation'
import { ROLES } from '../crm/helpers/role-management/role-mapping'

import { MANAGE } from '@eig-builder/core-utils/analytics/page-types'
import { NONE } from '@eig-builder/core-utils/analytics/flow-types'

const Routes = [
  {
    component: withDefaultNavigation(() => import('./configuration/index')),
    pageTitle: 'Management Portal - Translations configuration',
    documentTitle: 'Configuration - Translations',
    path: '/translations/configuration',
    requiredRole: [ROLES.BETA, ROLES.ADMIN_CST, ROLES.ADMIN_MP, ROLES.TRANSLATIONS, ROLES.DEV_ADMIN],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: withDefaultNavigation(() => import('./components/index')),
    pageTitle: 'Management Portal - Translations tool',
    documentTitle: 'Configuration - Translations tool',
    path: '/translations',
    requiredRole: [ROLES.BETA, ROLES.ADMIN_CST, ROLES.ADMIN_MP, ROLES.TRANSLATIONS, ROLES.DEV_ADMIN],
    pageType: MANAGE,
    flowType: NONE
  }
]

export default Routes
